

<template>
  <div class="shippingDetails">
    <div class="screen-panel" v-if="preloader">
      <div class="loader">
        <img src="../../assets/images/loader.gif" alt="loader" />
      </div>
    </div>
    <div class="pageShippingdtl" v-if="!preloader">
      <section class="main_content">
        <div class="order-id-block">
          <p>
            Order ID:
            <b>#{{orderDetails.orderId}}</b>
          </p>
        </div>
        <div
          class="product-card"
          v-if="subOrderDetails"
          @click="goToProductDetail(subOrderDetails.saleReferenceID,'NORMAL')"
        >
          <span class="product-img" v-if="subOrderDetails.itemImage">
            <img :src="subOrderDetails.itemImage" alt="order-image" />
          </span>
          <div class="product-detail">
            <div class="product-title">
              <h4>{{subOrderDetails.itemName}}</h4>
              <span class="product-price" v-if="orderDetails.subtotalAmount && parseFloat(orderDetails.codCharges) > 0">Rs. {{Math.round(parseFloat(orderDetails.subtotalAmount) + parseFloat(orderDetails.codCharges))}}.0</span>
              <span class="product-price" v-else>Rs. {{orderDetails.subtotalAmount}}</span>
            </div>
            <div class="color-size">
              <span class="product-color" v-if="subOrderDetails.color">
                {{$t('color')}} :&nbsp;
                <span class="colour">
                  <span>{{subOrderDetails.color}}</span>
                </span>
              </span>
              <span class="product-sz" v-if="subOrderDetails.size">
                {{$t('size')}} :&nbsp;
                <span class="size">{{subOrderDetails.size}}</span>
              </span>
            </div>
            <p v-if="orderDetails.orderDate">
              {{$t('orderDate')}}: {{ orderDetails.orderDate.slice(0, orderDetails.orderDate.indexOf(',')) }} | Mode:
              <span
                v-if="orderDetails.paymentMethod !='COD'"
              >Online</span>
              <span v-else>{{orderDetails.paymentMethod}}</span>
            </p>
          </div>
        </div>

        <div class="retunOrderbox" v-if="orderDetails.eligibleforReturn">
          <h2>{{$t('whyReturningThisProduct')}}</h2>
          <ul class="card-payment">
            <li
              class="container"
              v-for="(option,index) in listedReasons"
              :key="index"
              @click="changeDiscount(option.message)"
            >
              <p>{{option.message}}</p>
              <span class="checkmark" :class="{'active' : reason == option.message}"></span>
            </li>
          </ul>
          <textarea
            v-model="comment"
            class="inptTextareaBg"
            :placeholder="$t('tellYourProblemHere') "
          ></textarea>
          <div class="shipping_button">
            <button type="button" class="order-track-btn" @click="returnItem()">{{$t('returnItem')}}</button>
          </div>
        </div>

        <div class="retunOrderbox" v-else>
          <h2>
            <a @click="goToOrderDetail">{{$t('viewReturnDetail')}}</a>
          </h2>
        </div>
        <div class="price-details">
          <h2>{{$t('priceDetail')}}</h2>
          <!-- <p v-if="orderDetails.subtotalAmount">
            <span>{{$t('costPrice')}}</span>
            <span><span class="rupee-font">₹​</span>{{orderDetails.subtotalAmount}}</span>
          </p> -->
          <p v-if="orderDetails.subtotalAmount && parseFloat(orderDetails.codCharges) > 0">
            <span>{{$t('costPrice')}}</span>
            <span><span class="rupee-font">₹​</span>{{Math.round(parseFloat(orderDetails.subtotalAmount) + parseFloat(orderDetails.codCharges))}}.0</span>
          </p>
          <p v-else>
            <span>{{$t('costPrice')}}</span>
            <span><span class="rupee-font">₹​</span>{{orderDetails.subtotalAmount}}</span>
          </p>
          <p v-if="orderDetails.walletDiscountAmount > 0">
            <span>{{$t('walletDiscount')}}</span>
            <span><span class="rupee-font">₹​</span>{{orderDetails.walletDiscountAmount}}</span>
          </p>
          <p v-if="orderDetails.mcashDiscountAmount > 0">
            <span>{{$t('mpointsDiscount')}}</span>
            <span><span class="rupee-font">₹​</span>​ {{orderDetails.mcashDiscountAmount}}</span>
          </p>
          <p v-if="orderDetails.discountedAmount > 0">
            <span>{{$t('extraDiscount')}}</span>
            <span><span class="rupee-font">₹​</span>​ {{orderDetails.discountedAmount}}</span>
          </p>
          <p v-if="orderDetails.cuttingDiscountAmount > 0">
            <span>{{$t('cutFromFriendPrice')}}</span>
            <span><span class="rupee-font">₹​</span> {{orderDetails.cuttingDiscountAmount}}</span>
          </p>
          <p v-if="orderDetails.shoppingWalletDiscountAmount >0">
            <span>{{$t('shoppingWalletDiscount')}}</span>
            <span><span class="rupee-font">₹​</span>{{orderDetails.shoppingWalletDiscountAmount }}</span>
          </p>
          <p v-if="orderDetails.discountedPromoAmount >0">
            <span>{{$t('promoAmountDiscount')}}</span>
            <span><span class="rupee-font">₹​</span>{{orderDetails.discountedPromoAmount }}</span>
          </p>
          <p v-if="orderDetails.groupDiscount > 0">
            <span>{{$t('groupDiscount')}}</span>
            <span><span class="rupee-font">₹​</span>​ {{orderDetails.groupDiscount}}</span>
          </p>
          <!-- <p v-if="orderDetails.codCharges > 0" style="color: dodgerblue;">
            <span>{{$t('delivery')}}</span>
            <span>+ <span class="rupee-font">₹​</span>{{orderDetails.codCharges}}</span>
          </p>
          <p v-else>
            <span>{{$t('delivery')}}</span>
            <span class="green">FREE</span>
          </p> -->
          <!-- <p v-if="!orderDetails.treatShipmentCostSeparate">
            <span>{{$t('delivery')}}</span>
            <span class="green">FREE</span>
          </p> -->
          <p v-if="orderDetails.totalPaidAmount">
            <span>
              <b>{{$t('totalAmount')}}</b>
            </span>
            <span>
              <b><span class="rupee-font">₹​</span>​ {{orderDetails.totalPaidAmount}}</b>
            </span>
          </p>
        </div>
        <div class="card-payment">
          <label class="container">
            <input type="radio" name="radio" checked="checked" />
            <span class="checkmark"></span>

            <span class="payment-option-text" v-if="orderDetails.paymentMethod !='COD'">
              <span class="card-img">
                <svg xmlns="http://www.w3.org/2000/svg" width="26" height="26" viewBox="0 0 26 26">
                  <g fill="#000" fill-rule="nonzero" opacity=".561">
                    <path
                      d="M25.293 10.154L19.76.439a.86.86 0 0 0-1.184-.32L1.456 10.137h-.59a.873.873 0 0 0-.866.878v14.06c0 .485.388.878.867.878h24.266a.873.873 0 0 0 .867-.879V11.016a.875.875 0 0 0-.707-.862zm-14.987-.016l10.482-6.135.945 1.66-7.644 4.475h-3.783zm11.86-3.714l2.117 3.714h-8.461l6.345-3.714zM19.009.879l1.346 2.363-11.782 6.896H3.19L19.008.879zM.867 25.075V11.016h24.266v14.06H.867z"
                    />
                    <path
                      d="M21.667 18.925c-.546 0-1.076.176-1.517.502a2.577 2.577 0 0 0-3.631.586 2.66 2.66 0 0 0 .578 3.681c.91.67 2.143.67 3.053 0a2.575 2.575 0 0 0 3.627-.595 2.658 2.658 0 0 0-.587-3.677 2.573 2.573 0 0 0-1.523-.497zM16.9 21.56c.002-.973.78-1.76 1.74-1.758.449.001.88.178 1.204.495a1.784 1.784 0 0 1 .002 2.522 1.72 1.72 0 0 1-2.455-.035 1.773 1.773 0 0 1-.491-1.224zm4.767 1.757a1.717 1.717 0 0 1-.9-.251 2.726 2.726 0 0 0 .183-.316 2.545 2.545 0 0 0 .154-.376c.004-.01.009-.02.011-.03a2.62 2.62 0 0 0 .08-.343l.012-.083a2.405 2.405 0 0 0 0-.716l-.013-.084a2.636 2.636 0 0 0-.078-.341c-.003-.012-.009-.023-.012-.035a2.69 2.69 0 0 0-.117-.296l-.038-.08a2.752 2.752 0 0 0-.173-.297l-.008-.016a1.72 1.72 0 0 1 2.378.601 1.771 1.771 0 0 1-.592 2.412c-.268.163-.575.25-.887.251zM2.6 18.925h.867v.878H2.6zM4.333 18.925H5.2v.878h-.867zM6.067 18.925h.866v.878h-.866zM7.8 18.925h.867v.878H7.8zM9.533 18.925h.867v.878h-.867zM11.267 18.925h.866v.878h-.866zM13 18.925h.867v.878H13zM14.733 18.925h.867v.878h-.867zM2.6 21.56h12.133v.88H2.6zM3.467 16.288h2.6a.873.873 0 0 0 .866-.878v-1.758a.873.873 0 0 0-.866-.878h-2.6a.873.873 0 0 0-.867.878v1.758c0 .485.388.878.867.878zm0-2.636h2.6v1.758h-2.6v-1.758zM9.533 15.41h13a.873.873 0 0 0 .867-.879v-.879a.873.873 0 0 0-.867-.878h-13a.873.873 0 0 0-.866.878v.88c0 .484.388.878.866.878zm0-1.758h13v.88h-13v-.88z"
                    />
                  </g>
                </svg>
              </span>
              {{$t('onlinePayment')}}
            </span>

            <span class="payment-option-text" v-else>
              <span class="card-img">
                <svg xmlns="http://www.w3.org/2000/svg" width="26" height="26" viewBox="0 0 31 31">
                  <g fill="#000" fill-rule="nonzero" opacity=".561">
                    <path
                      d="M10.447 23.728a.632.632 0 0 0-.09-.218.58.58 0 0 0-.272-.222.596.596 0 0 0-.567.056.58.58 0 0 0-.223.27.587.587 0 0 0-.034.35.569.569 0 0 0 .09.219.58.58 0 0 0 .271.222.587.587 0 0 0 .35.035.569.569 0 0 0 .218-.09.58.58 0 0 0 .223-.272.611.611 0 0 0 .034-.35z"
                    />
                    <path
                      d="M27.851 23.915a.588.588 0 0 0-.007-.018c-.557-1.304-1.864-1.786-3.411-1.258l-4.218 1.167c-.244-.739-.853-1.367-1.713-1.686a.72.72 0 0 0-.016-.006L13.85 20.54c-.386-.499-1.595-1.775-3.859-1.775-1.581 0-2.98 1.085-3.781 2.268H.605a.605.605 0 0 0-.605.605v7.634c0 .334.271.605.605.605h3.6a.605.605 0 0 0 .606-.605v-.523h1.688a.605.605 0 0 0 .606-.605v-.175c.984.086 1.307.273 2.211.794a36.64 36.64 0 0 0 3.664 1.868 5.435 5.435 0 0 0 1.948.368c.61 0 1.299-.11 2.006-.43l9.324-3.338a.592.592 0 0 0 .049-.02c.89-.41 2.219-1.566 1.544-3.296zM3.6 28.666H1.21v-6.422H3.6v6.422zm2.294-1.128H4.81v-5.294h1.083v5.294zM25.823 26.1l-9.32 3.337a.747.747 0 0 0-.051.021c-1.298.597-2.532.24-3.015.051a35.074 35.074 0 0 1-3.516-1.795c-.99-.572-1.468-.847-2.816-.958v-4.877c.573-.94 1.686-1.903 2.886-1.903 2.058 0 2.93 1.338 2.964 1.392.074.12.188.211.322.256l4.812 1.634c.768.288 1.174.946.988 1.602a1.172 1.172 0 0 1-.561.708c-.273.152-.588.19-.889.107l-5.425-1.72a.605.605 0 1 0-.365 1.155l5.434 1.722a2.401 2.401 0 0 0 .675.097c.401 0 .799-.102 1.16-.303a2.375 2.375 0 0 0 1.172-1.582l4.546-1.259c.657-.224 1.519-.305 1.902.579.398 1.037-.635 1.608-.903 1.736zM21.74 7.965a.589.589 0 0 0-.09-.218.58.58 0 0 0-.272-.223.594.594 0 0 0-.463 0 .598.598 0 0 0-.362.44.596.596 0 0 0 .257.622.598.598 0 0 0 .336.102.607.607 0 0 0 .594-.723z"
                    />
                    <path
                      d="M30.395 2.052h-3.6a.605.605 0 0 0-.606.605v.523h-1.688a.605.605 0 0 0-.606.606v.174c-.984-.086-1.307-.273-2.211-.794a36.637 36.637 0 0 0-3.664-1.868c-.616-.242-2.23-.72-3.954.062l-2.436.872L9.576.18a.605.605 0 0 0-.856 0L1.977 6.92a.6.6 0 0 0 0 .856L13.5 19.3c.184.184.616.24.856 0l6.155-6.156c.16.014.326.021.499.021 1.581 0 2.98-1.085 3.781-2.267h5.605A.605.605 0 0 0 31 10.29V2.657a.605.605 0 0 0-.605-.605zM9.148 1.463l1.38 1.38c-.41.254-.885.39-1.38.39-.496 0-.97-.136-1.38-.39l1.38-1.38zM4.642 8.73l-1.38-1.38 1.38-1.38c.253.41.39.885.39 1.38 0 .496-.137.97-.39 1.38zm9.285 9.285l-1.38-1.38a2.636 2.636 0 0 1 2.76 0l-1.38 1.38zm2.252-2.252a3.848 3.848 0 0 0-4.504 0l-6.161-6.16c.473-.65.728-1.432.728-2.253 0-.82-.255-1.602-.728-2.252l1.382-1.382c.65.473 1.43.729 2.252.729.82 0 1.602-.256 2.252-.729l1.31 1.31a2.39 2.39 0 0 0-.815.278 2.373 2.373 0 0 0-.987 1.042 3.45 3.45 0 0 0 .63 6.843 3.44 3.44 0 0 0 2.44-1.009c.438-.438.744-.976.898-1.562l2.044.694a3.866 3.866 0 0 0 .641 3.069l-1.382 1.382zM12.498 9.81a.72.72 0 0 0 .016.005l1.21.411a2.243 2.243 0 0 1-3.771 1.097 2.243 2.243 0 0 1 .73-3.656c.112.93.782 1.76 1.815 2.143zm5.936 3.697a2.648 2.648 0 0 1-.387-1.26c.29.21.645.416 1.068.58l-.681.68zm5.461-3.457c-.573.94-1.686 1.903-2.886 1.903-.225 0-.435-.016-.632-.044h-.002c-1.308-.19-2.011-.933-2.243-1.228l-.073-.098a.603.603 0 0 0-.334-.278l-4.814-1.634c-.768-.288-1.174-.946-.988-1.602v-.001l.001-.002c.087-.302.285-.552.56-.705.273-.152.588-.19.889-.107l5.425 1.72a.605.605 0 1 0 .365-1.155L14.85 5.452l-.038-.038v-.001l-2.234-2.234 1.92-.687a.671.671 0 0 0 .02-.008l.007-.003a.58.58 0 0 0 .024-.01c1.298-.597 2.532-.24 3.015-.051a35.073 35.073 0 0 1 3.516 1.795c.99.572 1.468.847 2.816.958v4.877zm2.294-.364h-1.083V4.39h1.083v5.295zm3.6 0H27.4V3.263h2.39v6.423z"
                    />
                  </g>
                </svg>
              </span>
              {{$t('codPayment')}}
            </span>
          </label>
        </div>
      </section>
      <div class="loader" v-if="loading">
        <img src="../../assets/images/loader.gif" alt="loader" />
      </div>
    </div>
    <CustomToaster :dataValue="toasterData" v-if="isToasterData" />
  </div>
</template>
<script>
import constant from "../../utils/constant";
import ImageSpinner from "../Common/ImageSpinner";
import CustomToaster from "../../components/Common/CustomToaster";
export default {
  name: "ProductReturn",
  components: {
    ImageSpinner,
    CustomToaster
  },
  data() {
    return {
      orderDetails: {},
      extraDis: false,
      codEnabled: true,
      showCancel: true,
      orderDetails: {},
      subOrderDetails: {},
      loading: false,
      preloader: true,
      comment: "",
      reason: "",
      listedReasons: [],
      isToasterData: false
    };
  },
  methods: {
    changeDiscount(value) {
      this.reason = value;
    },
    goToOrderDetail() {
      this.$router.onError(err => {
        if (/loading chunk \d* failed./i.test(err.message)) {
          window.location.reload();
        }
      });
      this.$router.push("/shippingDetails/" + this.$route.params.orderId);
    },
    getOrdersById() {
      this.loading = true;
      this.$store
        .dispatch({
          type: "orderById",
          payload: this.$route.params.orderId
        })
        .then(data => {
          this.preloader = false;
          this.orderDetails = data.data;
          if (
            this.orderDetails &&
            this.orderDetails.subOrderDTOList &&
            this.orderDetails.subOrderDTOList.length > 0
          ) {
            this.subOrderDetails = this.orderDetails.subOrderDTOList[0];
          }
          this.loading = false;
        })
        .catch(err => {
          this.loading = false;
          console.log(err);
        });
    },
    goToProductDetail(productSrId, type) {
      this.$cookie.delete("type");
      this.$cookie.set("type", type);
      this.$router.onError(err => {
        if (/loading chunk \d* failed./i.test(err.message)) {
          window.location.reload();
        }
      });
      this.$router.push("/detail/" + productSrId);
    },
    returnItem() {
      if (this.reason && this.reason.length > 3) {
        const obj = {
          orderId: this.$route.params.orderId,
          comment: this.comment,
          reason: this.reason
        };
        this.loading = true;
        this.$store
          .dispatch({
            type: "orderReturnInitiate",
            payload: obj
          })
          .then(data => {
            if (data.data.requestStatus == "SUCCESS") {
              this.goToOrderDetail();
            } else {
              this.toasterData = {
                msg: data.data.appMessage,
                color: "#E51C24",
                iconName: "close"
              };
              this.isToasterData = true;
            }
            this.loading = false;
          })
          .catch(err => {
            this.loading = false;
            if (err.response.data.errorCodes[0] === "RETURN_NOT_ALLOWED_IN_PINCODE") {
              this.toasterData = {
                msg: this.$t("returnIsNotAvailAtPincode"),
                color: "#E51C24",
                iconName: "close",
              };
              this.isToasterData = true;
            }
            console.log(err);
          });
      } else {
        this.toasterData = {
          msg: this.$t("selectOneReason"),
          color: "#E51C24",
          iconName: "close"
        };
        this.isToasterData = true;
        return false;
      }
    }
  },
  created: function() {
    this.loading = true;
    this.$store
      .dispatch({
        type: "getReasonOrderReturn"
      })
      .then(data => {
        this.listedReasons = data.data.messageDTOs;
        this.loading = false;
      })
      .catch(err => {
        this.loading = false;
        console.log(err);
      });
  },
  mounted() {
    if (this.$route.params.orderId) {
      this.getOrdersById();
    } else {
      this.callbackFunction();
    }
  }
};
</script>
<style scoped lang="scss">
.retunOrderbox {
  border-top: 0;
  background: #fff;
  padding: 15px;
  margin-bottom: 8px;
  h2 {
    font-weight: 600;
    font-size: 1em;
    margin-bottom: 8px;
  }

  .inptTextareaBg {
    width: 100%;
    padding: 10px 5px;
    border-radius: 5px;
    background: #fff;
    font-size: 0.813em;
    font-weight: 500;
    color: #777;
    height: 75px;
    margin: 10px 0 0;
    resize: none;
    border: 1px solid rgba(0, 0, 0, 0.15);
  }
  .inptTextareaBg:focus {
    outline: 0;
  }

  .card-payment {
    width: 100%;
    padding: 0;
    background-color: white;

    .container {
      display: flex;
      align-items: center;
      position: relative;
      padding-right: 35px;
      font-size: 1em;
      color: #525252;
      user-select: none;
      margin-bottom: 20px;
      &:active {
        animation: buttonAnimation 0.5s 1;
      }

      &:last-child {
        margin-bottom: 10px;
      }

      .card-img {
        height: 26px;
        width: 26px;
        overflow: hidden;
        margin-right: 15px;
        flex-shrink: 0;

        img {
          height: 100%;
          width: 100%;
        }
      }

      input {
        position: absolute;
        opacity: 0;
        width: 98%;
      }
    }

    .checkmark {
      position: absolute;
      top: 0;
      right: 0;
      height: 24px;
      width: 24px;
      border: 1px solid #727272;
      background: #fff;
      border-radius: 50%;
    }
    .checkmark {
      &.active {
        border: 1px solid green;
        background: #fff;
        &::after {
          display: block;
        }
      }
    }

    .checkmark {
      &.active {
        &::after {
          top: 50%;
          left: 50%;
          width: 16px;
          height: 16px;
          border-radius: 50%;
          transform: translate(-50%, -50%);
          border-radius: 50%;
          background: green;
        }
      }
    }

    .checkmark {
      &.active {
        &::after {
          content: "";
          position: absolute;
          // display: none;
        }
      }
    }
  }
  @keyframes buttonAnimation {
    0% {
      transform: scale(1);
      background-color: rgba(255, 149, 0, 0.7);
    }
    100% {
      transform: scale(1);
      background-color: rgba(255, 149, 0, 0.7);
    }
  }
}
</style>